import React, { useEffect } from "react";
import { Input } from "antd";
import styles from "./styles/SearchBar.scss";

interface SearchInputI {
  error: any;
  value: any;
  isMobile: any;
  className?: any;
  placeholder?: string;
  onChange?: (e) => void;
  onKeyUp?: (e) => void;
  readOnly?: boolean;
  style?: React.CSSProperties;
}

const SearchInput = React.forwardRef((props: SearchInputI, ref) => {
  // @ts-ignore
  const { isMobile, ...rest } = props;

  useEffect(() => {
    if (rest.error) {
      // @ts-ignore
      ref && ref.current.blur();
    }
  }, [rest.error, rest.value]);

  useEffect(() => {
    return () => {
      // @ts-ignore
      ref && ref.current.blur();
    };
  }, []);

  return (
    <Input
      // @ts-ignore
      ref={ref}
      {...rest}
      enterKeyHint="search"
      className={`${rest.error ? styles.error : ""} ${styles.input}`}
    />
  );
});

SearchInput.defaultProps = {
  // @ts-ignore
  error: false
};

export default React.memo(SearchInput);



// WEBPACK FOOTER //
// ./src/containers/HomePage/SearchInput.tsx